import MeasureRepresentationType from "@/models/types/measure-representation-type.ts";
import MeasureType from "./measure-type.ts";

class MeasureRepresentation {
    measureRepresentationId: string;
    
    measureShapeId: string;
    
    name: MeasureRepresentationType;
    
    dataFormatType: Record<string, unknown> | undefined = undefined;
    
    dataFormatInstance: Record<string, unknown> | undefined = undefined;
    
    measureTypes: MeasureType[] = [];
    
    constructor(representationId: string, shapeId: string, name: string, dataFormatType: Record<string, unknown> | undefined, dataFormatInstance: Record<string, unknown> | undefined) {
        this.measureRepresentationId = representationId;
        this.measureShapeId = shapeId;
        this.name = name as MeasureRepresentationType;
        this.dataFormatType = dataFormatType;
        this.dataFormatInstance = dataFormatInstance;
    }
}

export default MeasureRepresentation;